import { Button, CircularProgress, FormHelperText, Grid, Stack, TextField } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import SubCard from 'ui-component/cards/SubCard'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { GetBankDetails } from 'API/LimitManagement/apis';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BackdropLoader from '../General/Loader';
import { HandleBankDepositByCash, HandleBankDepositByImps, HandleBankDepositByNeft } from 'API/DS_Wallet/api';
import SnackBar from '../General/SnackBar';
import { Box } from '@mui/system';
import { IoCloseCircle } from "react-icons/io5";


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    backgroundColor: '#5032a8',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    padding: 1,
    width: 1,
});

const BankDepositTab = () => {
    const [DepositMode, setDepositMode] = useState(null)
    const [BankDetails, setBankDetails] = useState(null)
    const location = useLocation()
    const [Error, setError] = useState({})

    const [Data, setData] = useState({})
    const[isLoading,setIsLoading]=useState(false)


    // Alert
    const [OpenAlert, setOpenAlert] = useState(false)
    const [AlertMessage, setAlertMessage] = useState("")
    const [AlertType,setAlertType]=useState("")


    const handleAlertOpen=(message,type)=>{
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)
    }

    const handleAlertClose = () => {
        setOpenAlert(false)
    }



    // console.log(location);

    useEffect(() => {
        GetBankDetails(setBankDetails)
    }, [])


    const handleChange = (event) => {
        if (event.target.value !== 'select') {

            setDepositMode(event.target.value);
            setData({})
        }
        else {
            setDepositMode(null);
        }

    };

    // console.log("data for change",Data);
    

    const fields_data = {
        // "cheque": [
        //     {
        //         name: 'fia_bank',
        //         display_name: "Fia Bank",
        //         type: 'text',
        //         value: 'SBI',
        //         disabled:true,
        //         required:false
        //     },
        //     {
        //         name: 'fia_account',
        //         display_name: "Fia Account",
        //         type: 'text',
        //         value: '32541170333',
        //         disabled:true,
        //         required:false
        //     },
        //     {
        //         name: 'cheque_no',
        //         display_name: "Cheque No",
        //         type: 'text',
        //         value: null,
        //         disabled:false,
        //         regex:/^[A-Za-z0-9]+$/,
        //         required:true
        //     },
        //     {
        //         name: 'ds_name',
        //         display_name: "DS Name",
        //         type: 'text',
        //         value: sessionStorage.getItem('UserName'),
        //         disabled:true,
        //         required:false
        //     },
        //     {
        //         name: 'amount',
        //         display_name: "Amount",
        //         type: 'text',
        //         value: location.state["total_amount"] ? location.state["total_amount"] : null,
        //         disabled: true,
        //         required:false
        //     },
        //     {
        //         name: 'transfer_date',
        //         display_name: "Transfer Date",
        //         type: 'date',
        //         value: null,
        //         disabled:false,
        //         required:true
        //     },
        //     {
        //         name: 'bank_name',
        //         display_name: "Bank Name",
        //         type: 'select',
        //         value: BankDetails,
        //         disabled:false,
        //         required:true
        //     },
        //     {
        //         name: 'bank_location',
        //         display_name: "Bank Location",
        //         type: 'text',
        //         value: null,
        //         disabled:false,
        //         regex:/^[A-Za-z]*$/,
        //         required:true
        //     },
        //     {
        //         name: 'branch_code',
        //         display_name: "Branch Code",
        //         type: 'text',
        //         value: null,
        //         disabled:false,
        //         required:true
        //     },
        //     {
        //         name: 'remarks',
        //         display_name: "Remarks",
        //         type: 'text',
        //         value: null,
        //         disabled:false,
        //         required:false
        //     },

        // ],
        "cash": [
            {
                name: 'fia_bank',
                display_name: "Fia Bank",
                type: 'text',
                value: 'SBI',
                disabled: true,
                required: false
            },
            {
                name: 'fia_account',
                display_name: "Fia Account",
                type: 'text',
                value: '32541170333',
                disabled: true,
                required: false
            },
            {
                name: 'ds_name',
                display_name: "DS Name",
                type: 'text',
                value: sessionStorage.getItem('UserName'),
                disabled: true,
                required: false
            },

            {
                name: 'amount',
                display_name: "Amount",
                type: 'text',
                value: location.state["total_amount"] ? location.state["total_amount"] : null,
                disabled: true,
                required: false
            },
            {
                name: 'transfer_date',
                display_name: "Transfer Date",
                type: 'date',
                value: null,
                disabled: false,
                required: true,
                maxDate: new Date()
            },
            
            {
                name: 'bank_location',
                display_name: "Bank Location",
                type: 'text',
                value: null,
                disabled: false,
                regex: /^[A-Za-z]*$/,
                required: true
            },
            {
                name: 'branch_code',
                display_name: "Branch Code",
                type: 'text',
                value: null,
                disabled: false,
                regex: /^([A-Za-z0-9 ]*|)$/,
                required: true
            },
            {
                name: 'city',
                display_name: "City",
                type: 'text',
                value: null,
                disabled: false,
                regex: /^[A-Za-z]*$/,
                required: true
            },
            {
                name: 'bank_recipt',
                display_name: "Bank / Txn Receipt",
                type: 'document',
                value: null,
                disabled: false,
                required: true
            },
            {
                name: 'remarks',
                display_name: "Remarks",
                type: 'text',
                value: null,
                disabled: false,
                required: false
            },

        ],
        "neft_rtgs": [
            {
                name: 'fia_bank',
                display_name: "Fia Bank",
                type: 'text',
                value: 'SBI',
                disabled: true,
                required: false
            },
            {
                name: 'fia_account',
                display_name: "Fia Account",
                type: 'text',
                value: '32541170333',
                disabled: true,
                required: false
            },

            {
                name: 'ds_name',
                display_name: "DS Name",
                type: 'text',
                value: sessionStorage.getItem('UserName'),
                disabled: true,
                required: false
            },
            {
                name: 'amount',
                display_name: "Amount",
                type: 'text',
                value: location.state["total_amount"] ? location.state["total_amount"] : null,
                disabled: true,
                required: false
            },
            {
                name: 'transfer_date',
                display_name: "Transfer Date",
                type: 'date',
                value: null,
                disabled: false,
                required: true,
                maxDate: new Date()
            },
            {
                name: 'bank_name',
                display_name: "Bank Name",
                type: 'select',
                value: BankDetails,
                disabled: false,
                required: true
            },
           
            {
                name: 'txn_ref_number',
                display_name: "Txn Ref No",
                type: 'text',
                value: null,
                disabled: false,
                regex: /^([A-Za-z0-9 ]*|)$/,
                required: true
            },
            {
                name: 'remarks',
                display_name: "Remarks",
                type: 'text',
                value: null,
                disabled: false,
                required: false
            },

        ],
        "imps": [
            {
                name: 'fia_bank',
                display_name: "Fia Bank",
                type: 'text',
                value: 'SBI',
                disabled: true,
                required: false
            },
            {
                name: 'fia_account',
                display_name: "Fia Account",
                type: 'text',
                value: '32541170333',
                disabled: true,
                required: false
            },

            {
                name: 'ds_name',
                display_name: "DS Name",
                type: 'text',
                value: sessionStorage.getItem('UserName'),
                disabled: true,
                required: false
            },
            {
                name: 'amount',
                display_name: "Amount",
                type: 'text',
                value: location.state["total_amount"] ? location.state["total_amount"] : null,
                disabled: true,
                required: false
            },
            {
                name: 'transfer_date',
                display_name: "Transfer Date",
                type: 'date',
                value: null,
                disabled: false,
                required: true,
                maxDate: new Date()
            },

            {
                name: 'imps_ref_number',
                display_name: "IMPS Ref No",
                type: 'text',
                value: null,
                disabled: false,
                regex: /^([A-Za-z0-9 ]*|)$/,
                required: true
            },
            {
                name: 'remarks',
                display_name: "Remarks",
                type: 'text',
                value: null,
                disabled: false,
                required: false
            },

        ],
    }


    const handleDataChange = (name, value, index) => {
        if (fields_data[DepositMode][index] && fields_data[DepositMode][index].regex) {
            if (value !== "select") {
                if (fields_data[DepositMode][index].regex.test(value)) {
                    setData({ ...Data, [name]: value });
                    setError({ ...Error, [name]: false })
                }
                else {
                    setData({ ...Data, [name]: Data[name] ? Data[name] + "" : "" })
                    setError({ ...Error, [name]: true })
                }
            }
            else {
                setData({ ...Data, [name]: null })
            }


        }
        else {
            // console.log("elseasdasd");
            if (value !== "select") {
                setData({ ...Data, [name]: value });
                setError({ ...Error, [name]: false })
            }
            else {
                setData({ ...Data, [name]: null })
            }

        }

    }



    // console.log("Data", Data);

    const handleSubmit = () => {
        let hasError = false;
        let newErrors = {};

        const updatedData = { ...Data };
        // console.log("Data",Data);
        
        fields_data[DepositMode].forEach((item) => {
            if (item.required && (!item.value&&item.type!=='select') && !Data[item.name]) {
                hasError = true;
                newErrors[item.name] = `${item.display_name} is required`;
            } 
            else if(item.required&&item.type==='select'&&!Data[item.name]){
                hasError = true;
                newErrors[item.name] = `${item.display_name} is required`;
            }
            else if (item.value&&item.type!=='select') {
                updatedData[item.name] = item.value;
                updatedData["sign_on_amount"]=location.state["sign_on"]?location.state["sign_on"]:0
                updatedData["hardware_amount"]=location.state["hardware"]?location.state["hardware"]:0
            }
        });

        setData(updatedData);
        setError(newErrors);

        if (!hasError) {
            switch(DepositMode){
                case 'cash':
                    HandleBankDepositByCash(updatedData, setIsLoading, handleAlertOpen)
                    break;
                case 'neft_rtgs':
                    HandleBankDepositByNeft(updatedData, setIsLoading, handleAlertOpen)
                    break;
                case 'imps':
                    HandleBankDepositByImps(updatedData, setIsLoading, handleAlertOpen)              
                    break;
                default:
                    break;
            }
        }
    };


    // console.log("Data", Data);



    return (
        <Grid container>
            <BackdropLoader open={isLoading}/>
            <SnackBar open={OpenAlert} type={AlertType} message={AlertMessage} handleClose={handleAlertClose}/>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <SubCard>
                    <Box sx={{position:"relative"}}>
                        <Button
                             variant='text' 
                             color='dark' 
                             onClick={() => window.history.back()}
                             sx={{ position: "absolute", top: 0, right: 0 ,fontSize:"24px"}}

                             ><IoCloseCircle /></Button>
                    </Box>
                    <Grid container>
                        <Grid item xl={4} lg={4} md={6} sm={12} xs={12} >
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Payment Deposit Mode</InputLabel>
                                <Select
                                    labelid="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={DepositMode ? DepositMode : 'select'}
                                    label="Payment Deposit Mode"
                                    onChange={handleChange}
                                >
                                    <MenuItem value={'select'}>Select</MenuItem>
                                    <MenuItem value={'cash'}>Cash</MenuItem>
                                    <MenuItem value={'neft_rtgs'}>NEFT/RTGS</MenuItem>
                                    <MenuItem value={'imps'}>IMPS</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>

            {
                DepositMode ?
                    BankDetails ?
                        <Grid container mt={1}>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <SubCard>
                                    <Grid container spacing={2}>
                                        {fields_data[DepositMode].map((field, index) => (
                                            <Grid item xl={4} lg={4} md={6} sm={12} xs={12} key={index}>
                                                <InputLabel>{field.display_name}<span style={{ color: 'red', visibility: field.required ? 'visible' : 'hidden' }}>*</span></InputLabel>
                                                {field.type === 'text' ?
                                                    <TextField
                                                        fullWidth
                                                        id={field.name}
                                                        error={Error[field.name] ? true : false}
                                                        required={field.required}
                                                        sx={{
                                                            input:{
                                                                background:field.value?"#f5f5f5":'inherit'
                                                            }
                                                        }}
                                                        helperText={Error[field.name] ? Error[field.name] : ''}
                                                        name={field.name}
                                                        value={field.value !== null ? field.value : Data[field.name]?Data[field.name]:""}
                                                        disabled={field.disabled}
                                                        onChange={(e) => handleDataChange(field.name, e.target.value, index)}
                                                    />
                                                    :
                                                    field.type === 'select' ?
                                                        <FormControl fullWidth>
                                                            <Select
                                                                error={Error[field.name] ? true : false}
                                                                id="demo-simple-select"
                                                                name={field.name}
                                                                value={Data[field.name] ? Data[field.name] : 'select'}
                                                                helperText={Error[field.name] ? Error[field.name] : ''}
                                                                required={field.required}
                                                                disabled={field.disabled}
                                                                onChange={(e) => handleDataChange(field.name, e.target.value)}
                                                            >
                                                                <MenuItem value={'select'}>Select</MenuItem>
                                                                {field.value.map((bank, index) => (
                                                                    <MenuItem key={index} value={bank}>{bank}</MenuItem>
                                                                ))}
                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{Error[field.name] ? Error[field.name] : ''}</FormHelperText>
                                                        </FormControl>
                                                        :
                                                        field.type === 'date' ?
                                                            <TextField
                                                                fullWidth
                                                                id={field.name}
                                                                error={Error[field.name] ? true : false}
                                                                type='date'
                                                                disabled={field.disabled}
                                                                helperText={Error[field.name] ? Error[field.name] : ''}
                                                                required={field.required}
                                                                name={field.name}
                                                                onKeyDown={(e)=>e.preventDefault()}
                                                                inputProps={{
                                                                    max: new Date().toISOString().split('T')[0]
                                                                }}
                                                                value={field.value ? field.value : Data[field.name]?Data[field.name]:""}
                                                                onChange={(e) => handleDataChange(field.name, e.target.value)}
                                                            />
                                                            :
                                                            field.type === 'document' ?
                                                                <Stack direction='row' justifyContent='center' alignItems='center' gap={1}>
                                                                    <TextField
                                                                        fullWidth
                                                                        id={field.name}
                                                                        error={Error[field.name] ? true : false}
                                                                        required={field.required}
                                                                        helperText={Error[field.name] ? Error[field.name] : 'upload .jpg, .jpeg, .png, .pdf format only'}
                                                                        name={field.name}
                                                                        placeholder=''
                                                                        value={Data[field.name] ? Data[field.name].name : ""}
                                                                        disabled={true}
                                                                        onChange={(e) => handleDataChange(field.name, e.target.value, index)}
                                                                    />
                                                                    <Button
                                                                        component="label"
                                                                        role={undefined}
                                                                        variant="contained"
                                                                        tabIndex={-1}
                                                                        color='secondary'
                                                                        startIcon={<CloudUploadIcon />}
                                                                    >

                                                                        <VisuallyHiddenInput
                                                                            type="file"

                                                                            onChange={(event) =>{
                                                                                if(event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/)){
                                                                                    handleDataChange(field.name, event.target.files[0])
                                                                                }
                                                                                else{
                                                                                    handleAlertOpen("Please upload .jpg, .jpeg, .png, .pdf format only","error")
                                                                                }
                                                                            }}
                                                                            multiple
                                                                        />
                                                                    </Button>
                                                                </Stack>
                                                                :
                                                                null
                                                }
                                            </Grid>
                                        ))}
                                        <Grid container mt={1} justifyContent='center'>
                                            <Grid item xl={2} lg={2} md={2}>
                                                <Button fullWidth variant="contained" color="secondary" onClick={() => handleSubmit()}>Submit</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                        </Grid>
                        :
                        <CircularProgress />
                    :
                    null


            }

        </Grid>
    )
}

export default BankDepositTab